import React from 'react'
import { Link } from 'react-router-dom'
import { BadgeButton, Subheading, getThemeColors } from '@offerzen/pinata'
import ChevronLeftIcon from '@offerzen/zenicon/ChevronLeftIcon'
import PencilIcon from '@offerzen/zenicon/PencilIcon'
import styles from './styles'
import AccessibleIcon from '../../../../CandidateExperience/components/AccessibleIcon'

const MobileTitleBar = ({
  title,
  candidateSlug,
  editing,
  toggleEditing,
  enabledForCurrentState,
  isEmpty,
  editButtonRef,
  editButtonAriaLabel,
}) => (
  <div className={styles.container}>
    <Link to={`/candidate/${candidateSlug}`}>
      <span className={styles.backButton}>
        <AccessibleIcon icon={ChevronLeftIcon} size={16} color={getThemeColors('primary').base} /> Back
      </span>
    </Link>

    <Subheading>
      <strong>{title}</strong>
    </Subheading>

    <If condition={!editing && toggleEditing && enabledForCurrentState && !isEmpty}>
      <BadgeButton
        innerRef={editButtonRef}
        ariaLabel={editButtonAriaLabel}
        icon={PencilIcon}
        theme="primary"
        onClick={() => toggleEditing(true)}
        className={styles.editButton}
      />
    </If>
  </div>
)

export default MobileTitleBar
